export default __webpack_public_path__ + "static/media/rocket_anim_78.7679b480.png";